<div class="main">
  <span class="text">{{ text === '1' ? '1 Stop' : text }}</span>
  <img
    alt=""
    src="../../../assets/img/icons/icon-cross.svg"
    (click)="deleteFilter()" />
</div>
